module.exports = __webpack_public_path__ + "static/media/10D.13a231b8.jpg";